import { get, patch, post } from "@readai/common/api";
import {
  ACSUrlResponse,
  PatchSAMLConfigBody,
  SAMLConfigView,
} from "@readai/common/types";

// Generate or retrieve the SAML ACS URL for a workspace.
export const getSamlAcsUrl = async (workspaceId: string): Promise<string> => {
  const response: ACSUrlResponse = await post(
    `/enterprise/workspaces/${workspaceId}/saml/acs-url`,
    {},
    {
      withCreds: true,
    },
  );

  return response.acsUrl;
};

// Retrieve the SAML configuration for a workspace.
export const getSamlConfig = async (
  workspaceId: string,
): Promise<SAMLConfigView> => {
  return get(`/enterprise/workspaces/${workspaceId}/saml`, { withCreds: true });
};

// Update the SAML configuration for a workspace.
export const updateSamlConfig = async (
  workspaceId: string,
  body: PatchSAMLConfigBody,
): Promise<void> => {
  await patch(`/enterprise/workspaces/${workspaceId}/saml`, body, {
    withCreds: true,
  });
};
